import { Fragment } from "react";
import Icon, { IconTypes } from "shared/ui/icon";
import Text from "shared/ui/typography/Text";
import { concatClassnames } from "shared/utils/concatClassnames";
import { BUSINESS_USPS } from "../../../entities/product-item-extra";

interface ProductItemExtraProps {
  className?: string;
}

const ZakelijkPaymentProductItemExtra = ({
  className = "",
}: ProductItemExtraProps) => {
  const usps = BUSINESS_USPS;

  return (
    <>
      <div
        className={concatClassnames(
          "gg-grid gg-h-fit gg-w-full gg-grid-cols-12 gg-gap-y-2.5 sm:gg-gap-y-3.5 md:gg-h-full lg:gg-h-fit",
          className,
        )}
      >
        {usps.map((usp, i) => (
          <Fragment key={i}>
            <div className="gg-col-span-9 gg-whitespace-nowrap">
              <Text className="gg-flex gg-items-center">
                <Icon name={IconTypes.CHECK} className="gg-mr-2.5" />
                {usp.title}
              </Text>
            </div>
            <div className="gg-col-span-3 gg-text-right">{usp.description}</div>
          </Fragment>
        ))}
      </div>
    </>
  );
};
export default ZakelijkPaymentProductItemExtra;
